import axios from "axios";

export const API = axios.create({
  baseURL: "https://cdn.contentful.com/spaces/vytxye4zymmf",
  headers: {}
});

export const getUserDetails = () => {
  return JSON.parse(localStorage.getItem("jmty-user"));
};

export const getRequest = async ({ url, params, token }) => {
  const currentUser = getUserDetails();

  var request = {
    url,
    method: "get",
    params
  };

  if (token && currentUser && currentUser.token) {
    request["headers"] = { authorization: `${currentUser.token}` };
  }

  const requestResponse = await API(request);

  return requestResponse;
};

export const postRequest = async ({ url, params, data, token, formData }) => {
  const currentUser = getUserDetails();

  var request = {
    url,
    method: "post",
    params,
    data
  };

  if (token && currentUser && currentUser.token) {
    request["headers"] = { authorization: `${currentUser.token}` };
  }

  if (formData) {
    request.headers = {
      ...request.headers,
      "Content-Type": "multipart/form-data"
    };
  }

  const requestResponse = await API(request);

  return requestResponse;
};

export const patchRequest = async ({ url, params, data, token }) => {
  const currentUser = getUserDetails();

  var request = {
    url,
    method: "patch",
    params,
    data
  };

  if (token && currentUser && currentUser.token) {
    request["headers"] = { authorization: `${currentUser.token}` };
  }

  const requestResponse = await API(request);

  return requestResponse;
};

export const putRequest = async ({ url, params, data, token }) => {
  const currentUser = getUserDetails();

  var request = {
    url,
    method: "put",
    params,
    data
  };

  if (token && currentUser && currentUser.token) {
    request["headers"] = { authorization: `${currentUser.token}` };
  }

  const requestResponse = await API(request);

  return requestResponse;
};

export const deleteRequest = async ({ url, params, data, token }) => {
  const currentUser = getUserDetails();

  var request = {
    url,
    method: "delete",
    params,
    data
  };

  if (token && currentUser && currentUser.token) {
    request["headers"] = { authorization: `${currentUser.token}` };
  }

  const requestResponse = await API(request);

  return requestResponse;
};